<template>
  <div
    v-if="product"
    class="flex flex-col w-full h-full bg-[--color-body-bg] lg:min-h-[240px]"
    :class="{
      'p-4 rounded-lg': backgroundColor !== 'bg-[--color-body-bg]',
      'pb-8 border-b b-[--color-gray-line]': backgroundColor === 'bg-[--color-body-bg]',
    }"
  >
    <router-link :to="link" class="w-full" @click="$emit('linkClick', $event)">
      <div class="w-full text-lg font-semibold truncate">
        {{
          // Innovadis custom: Get product name and when it is a variation, prefix with group name
          getProductName(product, true)
        }}
      </div>
      <div v-if="productGroupMaterial" class="truncate">{{ productGroupMaterial }}</div>
      <div class="grow items-center mt-4">
        <VcImage
          :src="product.imgSrc"
          :alt="product.name"
          size-suffix="md"
          class="size-full select-none rounded object-contain object-center aspect-video"
          :lazy="lazy"
        />
      </div>
    </router-link>
  </div>
</template>
<script setup lang="ts">
import type { Product } from "@/core/api/graphql/types";
import { CUSTOM_PROPERTY_GROUP_MATERIAL } from "@/shared/common/constants";
import { getCustomPropertyValue } from "@/core/utilities/innovadis";
import { computed } from "vue";
import { getProductRoute } from "@/core/utilities";
import { getProductName } from "@/core/utilities/innovadis"; // Innovadis custom

interface IProps {
  product: Product;
  lazy?: boolean;
  backgroundColor?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  lazy: true,
});

const link = computed(() => getProductRoute(props.product.id, props.product.slug));

// get group material value from product properties
const productGroupMaterial = computed(() =>
  getCustomPropertyValue(props.product.properties, CUSTOM_PROPERTY_GROUP_MATERIAL),
);
</script>
